import debug from 'bows';

const log = debug('i18n');

class I18n {
	constructor() {
		this.node = document.querySelector('.footer__content--i18n');
		if (!this.node) {
			return;
		}

			
		log('i18n', this);
	}
}

export default function () {
	return new I18n;
}